import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const getCards = async (deckId) => {
  const response = await axios.get(`${API_URL}/decks/${deckId}/cards`, {
    withCredentials: true
  });
  return response.data;
};

export const createCard = async (deckId, formData) => {
  const response = await axios.post(
    `${API_URL}/decks/${deckId}/cards`,
    formData,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response.data;
};

export const updateCard = async (deckId, cardId, formData) => {
  const response = await axios.put(
    `${API_URL}/decks/${deckId}/cards/${cardId}`,
    formData,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response.data;
};

export const deleteCard = async (deckId, cardId) => {
  const response = await axios.delete(
    `${API_URL}/decks/${deckId}/cards/${cardId}`,
    {
      withCredentials: true
    }
  );
  return response.data;
};

export const updateCardProgress = async (deckId, cardId, progressData) => {
  const response = await axios.put(
    `${API_URL}/decks/${deckId}/cards/${cardId}/progress`,
    progressData,
    {
      withCredentials: true
    }
  );
  return response.data;
}; 